import React from 'react';
import styled from 'styled-components';
import { IconCheck, black } from '@spotify-internal/encore-web';

export type CheckmarkPropTypes = {
  $checkmarkColor?: string;
  strokeWidth?: string;
  label?: string;
  size?: React.ComponentPropsWithoutRef<typeof IconCheck>['iconSize'];
  textDirection?: 'ltr' | 'rtl';
};

function CheckmarkComponent(props: CheckmarkPropTypes) {
  const { size = 24, label = '', ...rest } = props;

  return (
    <div {...rest}>
      <IconCheck iconSize={size} aria-label={label} />
    </div>
  );
}

const Checkmark = styled(CheckmarkComponent)`
  display: inline-block;
  color: ${({ $checkmarkColor }) =>
    $checkmarkColor ? $checkmarkColor : black};
  padding: ${({ textDirection }) =>
    textDirection === 'rtl' ? `0 0 0 10px` : `0 10px 0 0`};

  svg[class*='Svg-'] {
    stroke-width: ${({ strokeWidth }) => (strokeWidth ? strokeWidth : '2')}pt;
  }
`;

export default Checkmark;
